import React from "react";
import {} from "prop-types";
import SearchApp from "./SearchApp.jsx";
import {
  createStore,
  QueryStringProvider,
  QueryStringConsumer,
} from "../QueryStringContext/QueryStringContext.jsx";
import { DEFAULTS } from "../../common/useSearchValues.js";

const propTypes = {};
const queryStringStore = (props) => createStore(DEFAULTS, props);
const SearchPage = (props) => {
  return (
    <QueryStringProvider store={queryStringStore(props)}>
      <QueryStringConsumer>
        {(context) => (
          <SearchApp
            queryStringState={context.queryStringState}
            setQueryStringState={context.setQueryStringState}
            model={context.model}
            loggedIn={context.loggedIn}
          />
        )}
      </QueryStringConsumer>
    </QueryStringProvider>
  );
};

SearchPage.propTypes = propTypes;
export default SearchPage;
